import axios from 'axios';
import { showMessage } from '@/utils/utils';

const handleError = (error: any, toast: React.RefObject<any>) => {
    if (axios.isAxiosError(error) && error.response) {
        console.error('Error primero:', error);
        const { status, data } = error.response;

        // Manejo específico para el error 500
        if (status === 500) {
            console.error('Error 500: Internal Server Error');
            showMessage(toast, 'error', 'Error', 'Se ha producido un error en el servidor. Por favor, contacte con el administrador.');
            return;
        }

        // Otros errores específicos
        console.error('Error eespecific:', data);
        const errorMessage = typeof data.error === 'string' 
            ? data.error 
            : JSON.stringify(data.error);
        console.error('Error:', errorMessage);
        showMessage(toast, 'error', 'Error', errorMessage, 10000);
    } else {
        // Manejo de errores generales
        const generalErrorMessage = typeof error === 'string' 
            ? error 
            : JSON.stringify(error);
        console.error('Error:', generalErrorMessage);
        showMessage(toast, 'error', 'Error', generalErrorMessage, 10000);
    }
};

export default handleError;
